import { API_URL } from "../config";

const DEFAULT_LOGO = "/logowebinarplus.png";

export function resolveAssetUrl(path) {
  if (!path) return DEFAULT_LOGO;
  if (path.startsWith("http://") || path.startsWith("https://") || path.startsWith("data:")) {
    return path;
  }
  // File storico / default non presente in public
  if (path === "/Logo Rotondo.png" || path === "Logo Rotondo.png") {
    return DEFAULT_LOGO;
  }
  if (path.startsWith("/uploads/")) {
    const base = String(API_URL || "").replace(/\/$/, "");
    // Con proxy same-origin (API_URL vuoto) resta relativo al dominio pubblico
    if (!base) return path;
    return `${base}${path}`;
  }
  return path.startsWith("/") ? path : `/${path}`;
}

export function darkenHex(hex, amount = 0.12) {
  if (!hex || !hex.startsWith("#") || hex.length < 7) return "#002a5c";
  const num = parseInt(hex.slice(1, 7), 16);
  const r = Math.max(0, ((num >> 16) & 0xff) * (1 - amount));
  const g = Math.max(0, ((num >> 8) & 0xff) * (1 - amount));
  const b = Math.max(0, (num & 0xff) * (1 - amount));
  return `#${[r, g, b].map((v) => Math.round(v).toString(16).padStart(2, "0")).join("")}`;
}
